import { useMutation, useQueryClient } from "@tanstack/react-query"
import Modal from "components/modal"
import React, { useState } from "react"
import useSessionStore from "stores/session"
import useSnackbarStore from "stores/snackbar"
import useT from "utils/useT"

type Props = {
  trackId?: number
  submitterId?: string | number
}

const DeleteComment = ({ trackId, submitterId }: Props) => {
  const t = useT()
  const queryClient = useQueryClient()
  const [isOpen, setIsOpen] = useState(false)
  const toggleToast = useSnackbarStore((state) => state.toggleToast)
  const userId = useSessionStore((state) => state.user.uid)

  const accessToken = useSessionStore((state) => state.user.accessToken)
  const { mutate, isPending } = useMutation({
    mutationFn: () =>
      fetch(
        `/api/delete-comment?trackId=${trackId}&submitterId=${submitterId}&accessToken=${accessToken}&userId=${userId}`,
      ).then((res) => res.json()),
    onSettled(data) {
      if (data.acknowledged) {
        setIsOpen(false)
        toggleToast({
          text: "comment deleted successfully",
          color: "green",
        })
        queryClient.invalidateQueries({
          queryKey: ["fetchApp", String(trackId)],
        })
        queryClient.invalidateQueries({
          queryKey: ["getApps"],
        })
        queryClient.invalidateQueries({
          queryKey: ["getGames"],
        })
        queryClient.invalidateQueries({
          queryKey: ["getAll"],
        })
      } else {
        toggleToast({
          text: "comment deletion failed",
          color: "red",
        })
      }
    },
  })
  return (
    <div>
      <button
        className="icon icon-xxs rounded-m bg-danger color-white"
        onClick={() => setIsOpen(true)}
      >
        <i className="fa fa-trash"></i>
      </button>
      <Modal isCenter modalOpen={isOpen} close={() => setIsOpen(false)}>
        <div className="py-2">
          <h2 className="text-center font-700 mt-3 pt-1">
            {t.deleteComment.areYouSure}
          </h2>
          <p className="boxed-text-l">{t.deleteComment.commentWillBeDeleted}</p>
          <div className="row me-3 ms-3 mt-4">
            <div className="col-6">
              <button
                onClick={() => mutate()}
                className="w-100 close-menu btn btn-sm btn-full button-s shadow-l rounded-s text-uppercase font-900 bg-green-dark"
              >
                {isPending ? (
                  <div
                    className="spinner-border spinner-border-sm"
                    role="status"
                  />
                ) : (
                  t.deleteComment.yes
                )}
              </button>
            </div>
            <div onClick={() => setIsOpen(false)} className="col-6">
              <button className="w-100 close-menu btn btn-sm btn-full button-s shadow-l rounded-s text-uppercase font-900 bg-red-dark">
                {t.deleteComment.cancel}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default DeleteComment
